import { render, staticRenderFns } from "./RelatedDocumentsView.vue?vue&type=template&id=1c45646d&scoped=true"
import script from "./RelatedDocumentsView.vue?vue&type=script&lang=ts"
export * from "./RelatedDocumentsView.vue?vue&type=script&lang=ts"
import style0 from "./RelatedDocumentsView.vue?vue&type=style&index=0&id=1c45646d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45646d",
  null
  
)

export default component.exports